import { withDefaults } from '@warp-drive/legacy/model/migration-support';
import type { WithLegacy } from '@warp-drive/legacy/model/migration-support';
import type { Type } from '@warp-drive/core/types/symbols';

export type Flag = WithLegacy<{
  targetType: string | null;
  targetId: string | null;
  userId: string | null;
  reason: string | null;
  details: string | null;
  status: string | null;
  resolvedBy: string | null;
  resolutionNote: string | null;
  createdAt: string | null;
  updatedAt: string | null;
  [Type]: 'flags';
}>;

export const FlagSchema = withDefaults({
  type: 'flags',
  fields: [
    { name: 'targetType', kind: 'attribute', type: 'string' },
    { name: 'targetId', kind: 'attribute', type: 'string' },
    { name: 'userId', kind: 'attribute', type: 'string' },
    { name: 'reason', kind: 'attribute', type: 'string' },
    { name: 'details', kind: 'attribute', type: 'string' },
    { name: 'status', kind: 'attribute', type: 'string' },
    { name: 'resolvedBy', kind: 'attribute', type: 'string' },
    { name: 'resolutionNote', kind: 'attribute', type: 'string' },
    { name: 'createdAt', kind: 'attribute', type: 'string' },
    { name: 'updatedAt', kind: 'attribute', type: 'string' },
  ],
});
